import classNames from 'classnames';
import { useState } from 'react';
import { useProductPageContext } from '@/components/v2/product/hooks/useProductPageContext';
import ReviewsSummary from './ReviewsSummary';
import PrimaryTitleWithBadge from './PrimaryTitleWithBadge';
import { splitProductTitle } from './helpers';
import ReviewsModal from '../../../secondary/reviews/ReviewsModal';

type ProductInfoProps = {
  className: string;
  useHeading?: boolean;
};

export default function ProductInfo({
  className,
  useHeading = false,
}: ProductInfoProps) {
  const {
    selectedSkuDetails: { title },
    additionalInfo: { reviews },
  } = useProductPageContext();
  const { primaryTitle, secondaryTitle, showUnlocked } =
    splitProductTitle(title);
  const TitleTag = useHeading ? 'h1' : 'div';

  const [showReviewsModal, setShowReviewsModal] = useState(false);

  return (
    <div className={classNames('min-w-0', className)}>
      <div className="min-w-0" id="e2e-pdp-title">
        {/* The secondary title sits outside the heading: an <h1> may only hold
            phrasing content, so the variant line cannot be nested in it. */}
        <TitleTag
          aria-label={title}
          className="relative min-w-0 text-xl font-bold leading-none text-gray-700"
        >
          <PrimaryTitleWithBadge
            primaryTitle={primaryTitle}
            showUnlocked={showUnlocked}
          />
        </TitleTag>
        {secondaryTitle && (
          <div className="mt-1 text-sm font-medium leading-tight text-gray-700">
            {secondaryTitle}
          </div>
        )}
        <ReviewsSummary
          summary={reviews?.summary}
          className="mt-3 text-xs"
          onClick={() => setShowReviewsModal(true)}
        />
      </div>
      <ReviewsModal
        showModal={showReviewsModal}
        setShowModal={setShowReviewsModal}
      />
    </div>
  );
}
